function navigation() {
    (function($) {
        $(function() {
            const body = document.querySelector("body");
            const $fullscreenNav = $(".menu-full-wrap");
            /*
            $(".main-menu--top, .main-menu--full").each(function() {
                const $labelLinks = $("> li > a", this);
                const $list = this.find("li");
                //console.log($labelLinks);
                console.log($list);
                // these top level links should not go anywhere
                // removing href to disable links
                $labelLinks.removeAttr("href");
            });
            */

            $fullscreenNav.on(
                "webkitAnimationEnd mozAnimationEnd MSAnimationEnd oanimationend animationend",
                function() {
                    if ($(this).hasClass("fadeIn")) {
                        $(this).removeClass("fadeIn");
                    }

                    if ($(this).hasClass("fadeOutDownBig")) {
                        $(this).removeClass("fadeOutDownBig animated");
                    }
                }
            );

            $(".menu-toggle").on("click touch", function() {
                if ($(body).hasClass("fullscreen-menu")) {
                    $fullscreenNav.addClass("animated fadeOutDownBig");
                } else {
                    $fullscreenNav.addClass("animated fadeIn");
                }

                $(".menu-toggle__inner", this).toggleClass("animate");
                $(body).toggleClass("fullscreen-menu");
                $(".main-navigation--top").toggleClass(
                    "main-navigation--toggled-on"
                );
            });

            $(".close-menu-full").on("click touch", function() {
                $(".menu-toggle").click();
            });
        });
    })(jQuery);
}

export default navigation;



// WEBPACK FOOTER //
// ./src/js/partials/navigation.js